import { render, staticRenderFns } from "./MyinfoInfo.vue?vue&type=template&id=4c4a723e&scoped=true"
import script from "./MyinfoInfo.vue?vue&type=script&lang=js"
export * from "./MyinfoInfo.vue?vue&type=script&lang=js"
import style0 from "./MyinfoInfo.vue?vue&type=style&index=0&id=4c4a723e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4a723e",
  null
  
)

export default component.exports